import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

@Component({
  selector: "app-enroll-record-detail",
  templateUrl: "./enroll-record-detail.component.html",
  styleUrls: ["./enroll-record-detail.component.css"],
})
export class EnrollRecordDetailComponent implements OnInit {
  public detail: object = {};

  constructor(
    private httpService: HttpService,
    private activateInfo: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getPath();
    this.getDetail();
  }

  getDetail() {
    this.activateInfo.params.subscribe((params) => {
      console.log(params);
      this.httpService
        .getData(API.enrollRecordDetail + params["id"])
        .then((response) => {
          console.log(response);
          this.detail = response.data;
        });
    });
  }

  public imagePath: string;
  private getPath(): void {
    this.httpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/enroll-record-detail/enroll-record-detail.component.ts